var React = require("react");
const {  Link  } = require('react-router-dom');
var ApplicationContext = require("../config/ApplicationContext.js");

class Avatar extends React.Component {
    render() {
        let {style = "", link = false, type="img", letters="NN", onClick, 
            cursor = false, url = ApplicationContext.getDefaultUserAvatar()
        } = this.props;

        const Element = () => {
            if(type === "img"){
                return <img src={url} onClick={onClick}/>;
            }else{
                return <div className="avatar__letter" onClick={onClick}>{letters}</div>
            }
        }

        return  <div className={`avatar ${style} ${cursor ? "--cursor": ""}`}>
                        {link ? <Link to={link}><Element/></Link>: <Element/>}
                </div>
    }

}

module.exports = Avatar;